import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import {
  Card,
  Button,
} from '@lockerpm/design';

import modalsComponents from "../../../../../components/modals";

import authServices from "../../../../../services/auth";
import userServices from "../../../../../services/user";
import commonServices from "../../../../../services/common";

import global from "../../../../../config/global";

const { PasswordConfirmModal } = modalsComponents;

const DangerZone = (props) => {
  const { } = props
  const { t } = useTranslation();
  const [confirmDeleteDataVisible, setConfirmDeleteDataVisible] = useState(false);
  const [confirmDeleteAccountVisible, setConfirmDeleteAccountVisible] = useState(false);

  const [callingAPI, setCallingAPI] = useState(false);

  const handlePurgeData = async (password) => {
    setCallingAPI(true);
    const keyHash = await global.jsCore.cryptoService.hashPassword(password, null)
    await userServices.purge_data({ master_password_hash: keyHash })
      .then(async () => {
        global.pushSuccess(t('notification.success.account_details.purged'));
        await commonServices.sync_data(true);
        setConfirmDeleteDataVisible(false);
      }).catch((error) => {
        global.pushError(error)
      }
    )
    setCallingAPI(false);
  }

  const handleDeleteAccount = async (password) => {
    setCallingAPI(true);
    const keyHash = await global.jsCore.cryptoService.hashPassword(password, null)
    await userServices.delete_me({ master_password_hash: keyHash })
      .then(async () => {
        global.pushSuccess(t('notification.success.account_details.deleted'));
        await authServices.logout();
        setConfirmDeleteDataVisible(false);
      }).catch((error) => {
        global.pushError(error)
      }
    )
    setCallingAPI(false);
  }

  return (
    <div>
      <Card bodyStyle={{ padding: 16 }} className="mb-4">
        <div className="flex justify-between">
          <p className="font-semibold text-danger">
            {t('account_details.danger_zone.delete_data')}
          </p>
          <Button
            type='primary'
            danger
            ghost
            onClick={() => setConfirmDeleteDataVisible(true)}
          >
            {t('account_details.danger_zone.delete_data')}
          </Button>
        </div>
        <p className="mt-1">
          {t('account_details.danger_zone.delete_data_desc')}
        </p>
      </Card>
      <Card bodyStyle={{ padding: 16 }}>
        <div className="flex justify-between">
          <p className="font-semibold text-danger">
            {t('account_details.danger_zone.delete_account')}
          </p>
          <Button
            type='primary'
            danger
            ghost
            onClick={() => setConfirmDeleteAccountVisible(true)}
          >
            {t('account_details.danger_zone.delete_account')}
          </Button>
        </div>
        <p className="mt-1">
          {t('account_details.danger_zone.delete_account_desc')}
        </p>
      </Card>
      <PasswordConfirmModal
        width={480}
        visible={confirmDeleteDataVisible}
        title={t('account_details.danger_zone.delete_data')}
        description={
          <div>
            <div className="my-4 locker-callout danger">
              <p className="font-semibold">
                {t('account_details.danger_zone.delete_all_account_items')}
              </p>
              <p>
                {t('account_details.danger_zone.delete_all_account_items_desc')}
              </p>
            </div>
            <p>{t('password_confirm.confirm_note')}</p>
          </div>
        }
        okText={t('button.purge_account')}
        callingAPI={callingAPI}
        danger={true}
        onConfirm={handlePurgeData}
        onClose={() => setConfirmDeleteDataVisible(false)}
      />
      <PasswordConfirmModal
        width={480}
        visible={confirmDeleteAccountVisible}
        title={t('account_details.danger_zone.delete_account')}
        description={
          <div>
            <div className="my-4 locker-callout danger">
              <p className="font-semibold">
                {t('account_details.danger_zone.delete_locker_account')}
              </p>
              <p>
                {t('account_details.danger_zone.delete_locker_account_desc')}
              </p>
            </div>
            <p>{t('password_confirm.confirm_note')}</p>
          </div>
        }
        okText={t('button.delete_account')}
        callingAPI={callingAPI}
        danger={true}
        onConfirm={handleDeleteAccount}
        onClose={() => setConfirmDeleteAccountVisible(false)}
      />
    </div>
  );
}

export default DangerZone;